<template>
  <div id="about">
        <div class="jumbotron jumbotron-fluid feature" id="feature-first">
        <div class="container my-5">
            <div class="row justify-content-between text-center text-md-left">
                <div class="col-12" data-aos="fade" ata-aos-duration="1000" data-aos-once="true">
                    <h2 class="font-weight-bold py-3" style="color:#000">Why an Actions Commons Now?</h2>
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-5 align-self-center">
                    <img src="../assets/why.svg" alt="Take a look inside" class="mx-auto d-block">
                </div>
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-6 main-text" >
                    <p>
                        We are entering an era of permanent emergency. Our highly interconnected and interdependent
                        planet has many stress points and fault lines. Little cracks in the tightly wound systems keeping 
                        everything together easily trigger a new crisis.
                    </p>
                    <p>
                        Existing institutional forms are often too slow to respond, prompting an avalanche of agile forms of 
                        collaboration. These "Professional Volunteering Networks" are often made up of highly skilled professionals 
                        who come together to form nimble groups in response to gaps left by conventional problem solving systems in
                         the world today.
                    </p>
                    <p>
                        For such groups to be successful, legal certainty and low-cost risk management are critical 
                        since professionals are by and large conscious of reputational liabilities.
                    </p>
                    <p>
                         However, cost and time often make full and elaborate legal advice impractical in the throes 
                         of passionate action.
                    </p>
                                        <p>
                        Whilst pro bono legal assistance exists, it takes time to access and coordination issues 
                        can compound the delays.
                    </p>
                    <p>
                        The Leadership & Values Initiative grew out of the World Economic Forum's 2019 Africa Regional 
                        Strategy Group's workstreams. LEVI facilitates and amplify compassionate leadership based on altruistic,
                         self-sacrificing, action-oriented and cooperative behaviour. LEVI has from its inception promoted Professional 
                         Volunteering Networks (PVNs) as a powerful individual and collective leadership bridge between institutional 
                         capacity, on the one hand, and agile responses to Africa's and the World's urgent problems, on the other hand. 
                    </p>
                    <p>
                        "Rapid legal certainty and collaboration risk reduction" has been 
                        identified as a useful addition to the many resources needed to advance more 
                        multistakeholder collaboration driven by personal networks. ActionCommons is LEVI's 
                        undertaking to fill an important gap
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="jumbotron jumbotron-fluid feature" id="feature-last">
        <div class="container">
            <div class="row justify-content-between text-center text-md-left">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-5 align-self-center flex-md-first">
                    <img src="../assets/how.svg" alt="Safe and reliable" class="mx-auto d-block">
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-6  main-text">
                    <h2 class="font-weight-bold py-2">How Can We Help?</h2>
                    <p class="my-4">
                       We are asking top law firms around the world that have pro bono programs to come on board.
                    </p>
                    <p>
                         We believe that they are likely to have many documents used in the past for pro bono
                          clients that can be scrubbed clean of identification information, transformed into templates 
                          and model agreements, in the manner of UNIDROIT and International Chamber of Commerce model 
                          templates, and made available through this online portal for public benefit.
                    </p>
                    <p>
                         We are emphasising agreement and legal document templates that can benefit social movements, 
                         system-wide initiatives, volunteer networks and NGOs in particular. 
                    </p>
                    <p>
                        In essence, we are asking top law firms to "donate old work for new causes". Not much effort is
                         required on their part except their assistance in de-identification of the documents.
                    </p>
                    <p>
                        We hope we can count on your network.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="jumbotron jumbotron-fluid feature" id="feature-last">
        <div class="container">
            <div class="row justify-content-between text-center text-md-left">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-4 align-self-center flex-md-first">
                    <img src="../assets/priority.svg" alt="Safe and reliable" class="mx-auto d-block">
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-6  main-text">
                    <h2 class="font-weight-bold py-2">Priority list of Documents sought </h2>
                    <ul class="py-2">
                        <li>
                            A. Collaboration agreements 
                        </li>
                        <li>
                            B. Memoranda of Understanding
                        </li>
                        <li>
                            C. IP Assignment Agreements
                        </li>
                        <li>
                            D. Partnership Agreements 
                        </li>
                        <li>
                            E. Constitutions of non-profits and Companies limited by Guarantee 
                        </li>
                    </ul>
                    <p class="">
                        We will also consider any type of agreement that an organisation or voluntary group operating 
                        with a very minimal budget can use for various operational purpose with the necessary adjustments.
                    </p>
                </div>
            </div>
        </div>
    </div>
    
    <div class="jumbotron jumbotron-fluid feature" id="feature-last">
        <div class="container">
            <div class="row justify-content-between text-center text-md-left">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-4 align-self-center flex-md-first">
                    <img src="../assets/technology.svg" alt="Safe and reliable" class="mx-auto d-block">
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-6  main-text">
                    <h2 class="font-weight-bold py-2">Using Technology to Enhance Pro Bono Support</h2>
                    <p class="py-2"> Our ultimate objective requires the building of a forum on this Portal to deal with the
                     many risks that arise from using templates:
                    </p>
                    <ul>
                        <li>
                            A. Lawyers will register as contributors. 
                        </li>
                        <li>
                            B. Like wikipedia, they will share views and opinions on how best to use the documents. 
                        </li>
                        <li>
                             A ratings engine is being added.
                        </li>
                        <li>
                            D. An AI/Machine Learning algorithm will help organisations find agreements that best suit their context, scenario, and 
                            situation. Jurisdictional issues in particular shall be explored.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
  <div class="jumbotron jumbotron-fluid feature">
        <div class="container">
            <div class="row justify-content-between text-center text-md-left">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-4 align-self-center flex-md-first">
                    <img src="../assets/duty.svg" alt="Safe and reliable" class="mx-auto d-block">
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-6  main-text">
                    <h2 class="font-weight-bold py-2">Duty of Care to a Lay Audience</h2>
                   <p class="py-2">
                       A strong disclaimer has to be issued that this mechanism is still not a complete substitute 
                       for proper pro bono support from a reputable law firm.
                   </p>
                    <p>
                         For that reason we hope, in time, some law firms will use this Portal to identify the 
                         most deserving pro bono causes based on what users and downloaders of the documents 
                         state as the reason for accessing a particular template.
                    </p>
                </div>
            </div>
        </div>
    </div>
      <div class="jumbotron jumbotron-fluid feature" >
        <div class="container">
            <div class="row justify-content-between text-center text-md-left">
                <div data-aos="fade-right" data-aos-duration="1000" data-aos-once="true" class="col-md-3 align-self-center flex-md-first">
                    <img src="../assets/partner.svg" alt="Safe and reliable" class="mx-auto d-block">
                </div>
                <div data-aos="fade-left" data-aos-duration="1000" data-aos-once="true" class="col-md-6  main-text">
                <h2 class="py-2">Partnership Recognition</h2>
                  <p class="py-2">
                      Of course prominent credit shall be given to supporting law firms, and if they wish, 
                      they can be listed on the site in the "partners" section.
                  </p>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

#feature-first {
    background: linear-gradient(168deg, #ffffff 55%, #e7ebe9 0);
}

#feature-last {
    background: linear-gradient(-168deg,#e7ebe9 55%, #ffffff 0);
}
.jumbotron {
    margin-bottom: 0 !important;
}
h2 {
    font-size: 2rem !important;
    font-weight: 700;
    color:#fff;
}
img {
    display: block;
    max-width: 100%;
}
.main-text {
    background-color: #192440;
    color: #fff;
    padding:1.5em;
}
p {
text-align: justify;
}
ul li {
    text-align:justify;
    list-style: none;
}
</style>